import script from "./ExampleApp.vue?vue&type=script&setup=true&lang=js"
export * from "./ExampleApp.vue?vue&type=script&setup=true&lang=js"

import "./ExampleApp.vue?vue&type=style&index=0&id=62112430&lang=css"

const __exports__ = script;

export default __exports__